import { Component } from 'preact'
import { isChangeEvent } from '../../libs/typeGuards'

interface Props {
  class: string
  placeholder?: string
  maxLength?: number | undefined
  onContentChange?: (value: string) => void
  onTextareaFocus?: (e?: MouseEvent|FocusEvent) => void
  value?: string | number
  error?: boolean
  disabled?: boolean
  newStyle?: boolean
  verticalResize?: boolean
  adjustHeight?: boolean
  isDestination?: boolean
  disableGramm?: boolean
}

class Textarea extends Component<Props> {
  textareaElement: HTMLTextAreaElement | null = null
  constructor (props: Props) {
    super(props)
    this.adjustHeight = this.adjustHeight.bind(this)
  }

  componentDidUpdate () {
    if (this.props.adjustHeight) {
      this.adjustHeight()
    }
  }

  adjustHeight () {
    const el = this.textareaElement
    if (el === null) {
      return
    }
    const outerHeight = parseInt(getComputedStyle(el).height, 10)
    const diff = outerHeight - el.clientHeight
    el.style.height = '48px'
    el.style.height = String(el.scrollHeight + diff) + 'px'
  }

  render ({ class: customClass, placeholder, maxLength, onContentChange, value, error, disabled = false, newStyle = false, verticalResize = false, adjustHeight = true, isDestination = false, disableGramm = false }: Props) {
    if (error) {
      customClass += ' error'
    }

    if (disabled) {
      customClass += ' disabled'
    }

    if (newStyle) {
      customClass += ' textarea-new'
    }

    if (verticalResize) {
      customClass += ' textarea-vertical'
    }

    if (isDestination) {
      customClass += ' textarea-destination'
    } else {
      customClass += ' textarea-control'
    }

    const additionalAttributes = disableGramm ? { 'data-gramm': 'false' } : {}

    return (
      <textarea
        className={customClass}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        onChange={(e) => {
          if (onContentChange && isChangeEvent(e)) {
            onContentChange((e.target).value)
          }
        }}
        onFocus={this.props.onTextareaFocus}
        value={value}
        onInput={() => {
          if (adjustHeight) {
            this.adjustHeight()
          }
        }}
        ref={textarea => { this.textareaElement = textarea }}
        {...additionalAttributes}
      />
    )
  }
}

export default Textarea
